import React from "react";
import "../../../Styles/aboutUs.css";
import { Text } from "../../../subComponents/text";
import { MainHeading } from "../../../subComponents/MainHeading";

const AboutHeroSection = () => {
  return (
    <>
      <section className="about_hero_section">
        {/* about us hero left containner start from here */}
        <div className="about_hero_left_container">
          <div className="inner_about_left_container">
            <MainHeading
              orangeheading={"TUBE FLEX INDIA was established "}
              title={"in 2025 and is rapidly"}
              className={"heading_white"}
            />
            <hr style={{ color: "#fff", height: "2px" }} />
            <Text
              text={
                <>
                  TUBE FLEX INDIA was established in 2025 and is rapidly
                  expanding its services across India, focusing on outstanding
                  service records, collaborative partnerships, innovation, and
                  corporate responsibility. This company is recognized for
                  emphasizing growth through dedication to customer satisfaction
                  and the adoption of innovative practices in the extruded part
                  (Tube, Spiral & Profile) industry
                </>
              }
              style={{ color: "#fff", fontWeight: "300" }}
            />
            <Text
              text={
                <>
                  TUBE FLEX INDIAManufactures of Extruded &Moulding Parts & In
                  house with nylon and hose assemblies
                </>
              }
              style={{ color: "#fff", fontWeight: "300", marginTop: "1rem" }}
            />
            <Text
              text={
                <>Tool Room for extrusion die, Jig & Fixture manufacturing</>
              }
              style={{ color: "#fff", fontWeight: "300", marginTop: "1rem" }}
            />
          </div>
        </div>
        {/* about us hero left conatiner close fromm here */}

        {/* about hero right container start from here */}
        <div
          className="about_hero_right_container"
          style={{
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/images/AboutUs/about-page-banner.png"}
            alt={"about hero banner"}
            height={"100%"}
            width={"100%"}
          />
        </div>
        {/* about hero right container close from here */}
      </section>
    </>
  );
};
export { AboutHeroSection };
